const initialState = {
  translations: {},
};

export const SET_LANGUAGE_DATA = "SET_LANGUAGE_DATA";

export const SETLANGUAGEDATA = (data: any) => {
  return {
    type: SET_LANGUAGE_DATA,
    payload: data,
  };
};

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LANGUAGE_DATA:
      return {
        ...state,
        translations: payload,
      };

    default:
      return state;
  }
};

export default reducer;
